<template>
  <div class="analytics">
    <MainHeader
        class="analytics__header"
        title="Аналитика"
    />
    <div class="analytics__under-header">
      <AnalyticsPeriod class="analytics__period" query-param="analytics-period" v-model="dateRange"/>
      <VSegmentedControlQuery v-if="role === 'ADMIN'" class="analytics__tabs" :items="tabs"/>
    </div>

    <AnalyticsSummary  :items="vacancyData.summary"/>

    <div :class="isVacancy ? 'analytics__base-data-4': 'analytics__base-data-3'">
      <AnalyticsBaseData
          class="analytics__base-data"
          :items="itemsBaseData.data"
          :total="itemsBaseData.total"
          :headers="headersBaseData"
      />

      <AnalyticsWrapper
          v-if="isVacancy"
          title="План найма"
          :description="['Вакансия','Найм/План']"
          :items="vacancyData.hire_plan"
          padding-divider="0px"
          item-margin-bottom="0px"
          height="320"
      >
        <template #default="{item}" >
          <div style="padding: 0 24px" class="flex space-between" >
            <div style="max-width: 80%">
              <div class="title-description" :title="item.title" style="font-size: 14px; font-weight: 500; margin-bottom: 4px">
                {{item.title}}
              </div>
              <div style="color: #566A83; font-size: 12px">{{item.managers}} {{declineManager(item.managers)}}</div>
            </div>
            <div style="font-size: 14px; margin-top: 10px" class="flex space-between">
              <div style="font-weight: 500;">{{item.hired}}</div>
              <div style="color: #8F9CAC; font-weight: 400">/{{item.plan === 'Not defined' ? '-' : item.plan }}</div>
            </div>

          </div>
          <VSlider style="padding: 0 24px; margin-top: 8px; margin-bottom: 16px;" no-number :current="Number(item.hired)" :max="Number(item.plan)" two-color="#26A659"/>
        </template>
      </AnalyticsWrapper>

    </div>

    <div class="analytics__graph-4">

      <AnalyticsGraphCol :key="keyAll" class="analytics__graph" :items="vacancyData.source_analysis"/>

      <AnalyticsWrapper
          title="План найма"
          :description="['Источник','Доля/Изм.']"
          :items="vacancyData.source_analysis"
          padding-divider="0px"
          item-margin-top="0px"
          item-margin-bottom="0px"
      >
        <template #default="{item}" >
          <div class="substrate" :style="progressStyle(item.applied_delta, item.applied_share)"></div>
          <div style="padding: 0 24px; height: 44px;"   class="flex space-between">
            <div class="flex vertical-center" style="font-size: 12px; width: 116px; font-weight: 500; color: #1E3959">{{item.title}}</div>
            <div style="font-size: 12px;" class="flex space-between vertical-center">
              <div style="font-size: 14px;" class="bold">{{formatNum(item.applied_share)}}%</div>
              <div class="delta" :style="getColor(item.applied_delta)">&nbsp;{{formatNum(getFormatCount(item.applied_delta))}}</div>
            </div>
          </div>
        </template>
      </AnalyticsWrapper>
    </div>

    <div class="analytics__graph-4">
      <AnalyticsGraph  class="analytics__graph" :key="itemsGraph.data?.length + itemsGraph.total + keyAll" :items="itemsGraph.data" :total="itemsGraph.total"/>
      <AnalyticsWrapper
          title="Отказы"
          :description="['Причина','Сумма/Изм.']"
          :items="sortedData(itemsGraph.data? itemsGraph.data : [])"
          padding-divider="0px"
          item-margin-top="0px"
          item-margin-bottom="0px"
      >
        <template #default="{item}" >
          <div style="padding: 0 24px; height: 46px" class="flex space-between">
            <div class="flex vertical-center" style="font-size: 12px; width: 116px; font-weight: 500; color: #1E3959">{{item.title}}</div>
            <div style="font-size: 12px;"  class="flex space-between vertical-center">
              <div style="font-size: 14px;" class="bold">{{formatNum(item.count)}}</div>
              <div class="delta" :style="getColor(item.share, 1, true)">&nbsp;{{formatNum(getFormatCount(item.share))}}</div>
            </div>
          </div>
        </template>
      </AnalyticsWrapper>
    </div>

    <div class="analytics__funnel">
      <AnalyticsFunnel
          class="analytics__base-data"
          :items="itemsFunnel.data"
          :total="itemsFunnel.total"
          :headers="headersFunnel"
      />
    </div>
  </div>
</template>
<script setup>


import MainHeader from "@/components/MainHeader/index.vue";
import AnalyticsPeriod from "@/components/Analytics/period.vue";
import AnalyticsSummary from "@/components/Analytics/summary.vue";
import AnalyticsGraphCol from "@/components/Analytics/graphCol.vue";
import AnalyticsBaseData from "@/components/Analytics/baseData.vue";
import AnalyticsFunnel from "@/components/Analytics/funnel.vue";
import AnalyticsWrapper from "@/components/Analytics/wrapper.vue";
import AnalyticsGraph from "@/components/Analytics/graph.vue";
import VSegmentedControlQuery from "@/components/UI/VSegmentedControlQuery/index.vue";
import {computed, ref, watch} from "vue";
import {useRoute} from "vue-router";
import {MANAGER, VACANCY} from "../../../mocks";
import VSlider from "@/components/UI/VSlider/index.vue";
import analytics from "@/api/analytics";
import {declineManager, formatNum, getColor, getFormatCount, progressStyle} from "@/utils";
import {useStore} from "vuex";
const store = useStore();
const role = store.getters["auth/role"];
const tabs = [
  {
    id: "by-vacancies",
    label: "Вакансия",
  },
  {
    id: "by-hr",
    label: "Менеджер",
  },
];


const route = useRoute();
const keyAll = ref(0)

const dateRange = ref('')
const vacancyData = ref({});

const isVacancy = computed(() => {
  return route.query?.tabs === tabs[0].id
});

const mocks = computed(() => {
  return isVacancy.value ? VACANCY : MANAGER
})
const headersBaseData = computed(() => {
  return isVacancy.value ? [
    {text: 'Вакансия', value: 'title', align: 'left', width: '400px'},
    {text: 'Время', value: 'time', width: '180px', info: 'Совокупное время'},
    {text: 'Конверсия', value: 'conversion_value', width: '180px', info: 'За период'}
  ] : [
    {text: 'Менеджер', value: 'title', width: '500px'},
    {text: 'Время', value: 'time', width: '180px', info: 'Совокупное время'},
    {text: 'Конверсия', value: 'conversion_value', width: '180px', info: 'За период'},
    {text: 'Закрыто', value: 'closed', width: '180px', info: 'Закрыто за период'}
  ]
})

const headersFunnel = [
  {text: 'Вакансия', value: 'title', align: 'left', width: '150px'},
  {text: 'Всего', value: 'total', align: 'left', width: '97px'},
  {text: 'Резюме', value: 'resume', align: 'left', width: '97px'},
  {text: 'Документы', value: 'documents', align: 'left', width: '97px'},
  {text: 'Медкомиссия', value: 'medical_check', align: 'left', width: '97px'},
  {text: 'Билеты', value: 'tickets', align: 'left', width: '97px'},
  {text: 'Приняты', value: 'accepted', align: 'left', width: '97px'},
  {text: 'Конверсия', value: 'conversion', align: 'left', width: '97px'},
]

const itemsBaseData = computed(() => {
  return {
    data: vacancyData.value?.basic_data?.data ? vacancyData.value?.basic_data?.data : [],
    total: vacancyData.value?.basic_data?.total ? vacancyData.value?.basic_data?.total : [],
  }
})

const itemsFunnel = computed(() => {
  return {
    data: vacancyData.value?.funnel?.data ? vacancyData.value?.funnel?.data : [],
    total: vacancyData.value?.funnel?.total ? vacancyData.value?.funnel?.total : []
  }
})

const itemsGraph = computed(() => {
  return  {
    data: vacancyData.value?.rejection_reasons ? vacancyData.value?.rejection_reasons?.data : [],
    total: vacancyData.value?.rejection_reasons ? vacancyData.value?.rejection_reasons?.total_rejections : []
  }
})

const sortedData = (data) => {
  return data.sort((a, b) => {
    // Если один из элементов - "Другие", он всегда идет в конец
    if (a.title === "Другие") return 1;
    if (b.title === "Другие") return -1;
    // Остальные сортируем по убыванию count
    return b.count - a.count;
  })
}

watch(() => dateRange.value, () => {
  getData(dateRange.value)
})

watch(() => route.query?.tabs, () => {
  getData(dateRange.value)
})


const getData = async (data) => {
  let queryData = `?date_start=${data.start}&date_end=${data.end}`
  vacancyData.value = {}
  vacancyData.value = await analytics.getDataAnalytics(route.query.tabs,queryData)
  keyAll.value++
}

</script>
<style scoped lang="scss">
.analytics {
  padding-top: 24px;


  &__header {

  }

  &__under-header {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 24px;
  }

  &__tabs {
    height: 48px;
    width: 265px;
  }

  &__period {
    height: 48px;
    width: 265px;
    font-size: 14px;
    border-radius: 8px;
    background-color: #fff;
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $grey-text;
  }

  &__base-data-3 {
    display: grid;
    margin-top: 25px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  &__base-data-4 {
    display: grid;
    margin-top: 25px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
  }

  &__graph-4 {
    display: grid;
    margin-top: 20px;
    margin-bottom: 20px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
  }

  &__graph {
    grid-column: span 3;
  }

  &__base-data {
    grid-column: span 3;
  }

  .delta {
    //width: 40px;
    text-align: right;
  }

  .substrate {
    position: absolute;
  }


}
.title-description {
  white-space: nowrap;      /* Запрещаем перенос строк */
  overflow: hidden;        /* Скрываем текст, выходящий за границы */
  text-overflow: ellipsis; /* Добавляем многоточие */
}
</style>